<template>
  <div class="col-md-12">
    <div class="title-heading d-flex justify-content-between">
      <h1>{{ $static('inst.t1', 'Instagram') }}</h1>
    </div>
    <div class="large-button-panel align-items-center inst-button-panel" v-if="connected">
      <div class="buttons d-flex align-items-center">
        <div class="default-checkbox with-border mb-0">
          <input id="select_all_posts" name="select_post" type="checkbox" v-model="selectAll">
          <label for="select_all_posts" v-if="selectAll">{{ $static('inst.sel1', 'Зняти виділення') }}</label>
          <label for="select_all_posts" v-else>{{ $static('inst.sel2', 'Виділити все') }}</label>
        </div>
        <div class="button-panel mt-0" v-if="access_key" style="margin-left: 15px;">
          <button class="default-btn btn-accent" @click="saveSettings" :class="{ 'disable': importList.length === 0 }">
            <span class="text">{{ $static('inst.btnadsel', 'Додати виділене') }}</span>
          </button>
        </div>

        <div class="insta-counter">
          <p>{{ importList.length }}<span>/</span><span>{{ media.length }}</span></p>
        </div>
      </div>
      <div class="inst-logout">
        <div class="avatar-wrapper d-flex align-items-center">
          <a href="javascript:void(0)" @click="disconnect">
            <!--            <span class="avatar bg" style="background-image: url(/images/avatar.png);"> </span>-->
            <span class="text">{{ $static('inst.btnlogout', 'Вийти з Instagram') }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="inst-panel">
      <div class="row">
        <div class="col">

          <p class="text-center" style="max-width: 600px; margin: 0 auto; font-size: 18px;" v-if="!connected">
            1. Щоб під'єднати інстаграм вам потрібно надіслати посилання на ваш обліковий запис до центру
            <a style="text-decoration: underline;" href="https://t.me/UXWebSupportBOT">
              нашої підтримки
            </a>
            <br>
            (приклад: https://www.instagram.com/uxweb_bot/)<br><br>

            2. Після того як ми додамо ваш обліковий запис - вам потрібно буде прийняти запрошення на сторінці <br>
            <a href="https://www.instagram.com/accounts/manage_access/" style="text-decoration: underline;">
              https://www.instagram.com/accounts/manage_access/
            </a>
          </p>
          <div class="connect-button" style="display:flex" v-if="!connected">
            <a class="default-btn btn-accent" :href="connectURL">
              <span class="text">{{ $static('inst.btnconnect', 'Підключити') }}</span>
            </a>
          </div>
          <div class="inst-holder" v-if="connected">
            <div v-if="media.length === 0">
              <p>{{ $static('inst.errtext', 'Неможливо завантажити ваші пости') }}</p>
            </div>
            <div class="inst-wrapper">
              <div class="left-side">
                <div class="inst-posts-container">
                  <div class="insta-grid">
                    <div v-for="(item, index) in media" :key="index" class="insta-item"
                      :class="'insta_' + item.media_type.toLowerCase()">
                      <div class="insta-check-holder" v-if="item.media_type === 'VIDEO'">
                        <p>VIDEO NOT SUPPORTED</p>
                      </div>
                      <div class="insta-check-holder" v-else>
                        <input type="checkbox" :id="'md' + index" :value="item" v-model="importList">
                        <label :for="'md' + index">
                          <img :src="item.media_url" width="100" alt="">
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="inst-load-more" v-if="this.nextPage">
                  <a href="javascrpit:void(0)" @click="loadMore" class="default-btn btn-white btn-with-icon">
                    <span class="text">{{ $static('inst.btnmore', 'Завантажити ще') }}</span>
                    <span class="icon icon-add"></span>
                  </a>
                </div>
              </div>
              <div class="panel right-side">
                <div class="row">
                  <div class="col">
                    <div class="insta-info" style="margin: 0; border: none;padding-top: 0">
                      <h3>{{ $static('inst.t2', 'Інструкція') }}</h3>
                      <ul
                        v-html="$static('inst.doc', '<li>1. Виділіть фотографії які ви хочете додати.</li><li>2. Заповніть характеристики товарів на фотографіях.</li>')">

                      </ul>
                      <a class="default-link" data-toggle="collapse" href="#collapse_insta_info" role="button"
                        aria-expanded="false" aria-controls="collapse_insta_info">
                        <span class="text">{{ $static('inst.readmore', 'Читати повністю') }}</span>
                        <span class="icon icon-down"></span>
                      </a>
                      <div class="collapse" id="collapse_insta_info">
                        <p
                          v-html="$static('inst.doc', 'Рекомендуємо додавати товари зі схожими характиристками - наприклад ціною і категорією.<br> Унікальні характеристики як наприклад опис рекомендуємо додавати у вкладці каталогу')">
                        </p>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <div class="custom-label">{{ $static('inst.t3', 'Назва товару:') }}</div>

                      <input type="text" class="form-control custom-input" v-model="info.title">
                    </div>
                    <div class="form-group">
                      <label class="custom-label">{{ $static('ei.t3', 'Категорія продукції:') }}</label>
                      <div class="selector-holder">
                        <v-select :searchable="false" id="editor_category" :options="categoriesOptions"
                          :reduce="c => c.value" v-model="category">
                          <template #open-indicator="{ attributes }">
                            <span v-bind="attributes">
                              <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                                  fill="#212121" />
                              </svg>
                            </span>
                          </template>
                        </v-select>
                      </div>
                    </div>
                    <!--                    <div class="form-group">-->
                    <!--                      <label class="custom-label" for="editor_category">категория товара:</label>-->
                    <!--                      <div class="selector-holder">-->
                    <!--                        <v-select id="editor_category" :options="categoriesOptions" v-model="info.category">-->
                    <!--                          <template #open-indicator="{ attributes }">-->
                    <!--                          <span v-bind="attributes">-->
                    <!--                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                    <!--                              <path fill-rule="evenodd" clip-rule="evenodd"-->
                    <!--                                    d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"-->
                    <!--                                    fill="#212121"/>-->
                    <!--                            </svg>-->
                    <!--                          </span>-->
                    <!--                          </template>-->
                    <!--                        </v-select>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <div class="custom-label">{{ $static('inst.t4', 'Ціна:') }}</div>
                          <input type="text" class="form-control custom-input" v-model.number="info.price">
                        </div>
                        <div class="option-box">
                          <div class="option-line d-flex align-items-center justify-content-between">
                            <div class="option-name">{{ $static('inst.t5', 'Наявність товару:') }}</div>
                            <div class="toggle-holder">
                              <div class="toggler r">
                                <input type="checkbox" class="toggle-check" v-model="info.stock">
                                <div class="knobs"></div>
                                <div class="layer"></div>
                              </div>
                            </div>
                          </div>
                          <div class="option-line d-flex align-items-center justify-content-between">
                            <div class="option-name">{{ $static('inst.t6', 'Приховати товар') }}</div>
                            <div class="toggle-holder">
                              <div class="toggler r">
                                <input type="checkbox" class="toggle-check" v-model="info.hidden">
                                <div class="knobs"></div>
                                <div class="layer"></div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <div class="custom-label">{{ $static('inst.t7', 'Стара ціна:') }}</div>
                          <input type="text" class="form-control custom-input" v-model.number="info.price_old">
                        </div>
                        <div class="option-box">
                          <div class="option-line d-flex align-items-center justify-content-between">
                            <div class="option-name">{{ $static('ei.t8', 'Вивести в топ') }}</div>
                            <div class="toggle-holder">
                              <div class="toggler r">
                                <input type="checkbox" class="toggle-check" v-model="info.priority">
                                <div class="knobs"></div>
                                <div class="layer"></div>
                              </div>
                            </div>
                          </div>
                          <div class="option-line d-flex align-items-center justify-content-between">
                            <div class="option-name">{{ $static('ei.t9', 'Новинки') }}</div>
                            <div class="toggle-holder">
                              <div class="toggler r">
                                <input type="checkbox" class="toggle-check" v-model="info.advanced.hot">
                                <div class="knobs"></div>
                                <div class="layer"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">

                    <div class="custom-tabs">
                      <ul class="nav nav-tabs">
                        <li class="active"><a data-toggle="tab" href="#tab1">{{ $static('ei.tab1', 'Опис') }}</a></li>
                        <li><a data-toggle="tab" href="#tab2">{{ $static('ei.tab2', 'Характеристики') }}</a></li>
                      </ul>

                      <div class="tab-content">
                        <div id="tab1" class="tab-pane fade in active">
                          <div class="custom-editor-holder">
                            <editor :small="true" v-model="info.description"></editor>
                          </div>
                        </div>
                        <div id="tab2" class="tab-pane fade">
                          <div class="custom-editor-holder">
                            <editor :small="true" v-model="info.advanced.text1"></editor>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <!--sizes-->
                    <div class="size-panel mb-1" v-for="(option, index) in optionsTags" :key="index">
                      <div class="custom-label">{{ option.option }}:</div>
                      <div class="size-checkbox-group">
                        <!--size checkbox-->
                        <div class="option-checkbox" v-for="(item, index) in option.list" :key="index">
                          <input :id="item.option_id + index" type="checkbox"
                            @change="selectOption(item.option_id, item.id)"
                            :checked="selectedOption(item.option_id, item.name) > -1" :value="item.id"
                            :name="option.option_id">
                          <label :for="item.option_id + index">{{ item.name }}</label>
                        </div>
                        <!--end size checkbox-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api'
import Editor from '@/components/Editor';

export default {
  name: 'AppInstagram',
  components: { Editor },
  data() {
    return {
      access_key: undefined,
      fetching: false,
      connected: false,
      media: [],
      nextPage: undefined,
      importList: [],
      info: {
        category: '',
        title: '',
        price: 0,
        price_old: 0,
        priority: false,
        stock: false,
        hidden: true,
        advanced: {
          upsale: [],
          options: {},
          lined: [],
          hot: false
        }
      }
    }
  },
  mounted() {
    let key = window.localStorage.getItem('INSTA_ACCESS');
    if (key) {
      try {
        this.access_key = JSON.parse(key);
        this.fetchMedia();
      } catch (err) {
        this.access_key = undefined;
        window.localStorage.removeItem('INSTA_ACCESS');
      }
    }
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params.code) {
      fetch('https://ux.im/integrate/get-key?code=' + params.code)
        .then(response => response.json())
        .then(data => {
          if (!data.error_message) {
            data.time = new Date().getTime();
            window.localStorage.setItem('INSTA_ACCESS', JSON.stringify(data));
            this.access_key = data;
            this.$router.push({ name: this.$route.name });
            this.fetchMedia();

          }
        });
    }

    api.get('/api/options').then(response => response.data).then(data => {
      this.$store.commit('setOptions', data)
    }).then(() => {
      if (this.categoriesOptions.length) {
        this.info.category = this.categoriesOptions[0].value
      }
    });
  },

  computed: {
    connectURL() {
      return 'https://ux.im/integrate/instagram-in?cb=' + window.location.href
    },
    selectAll: {
      get() {
        return this.importList.length > 0
      },
      set(value) {
        let select = this.importList.length;
        this.importList = [];
        if (!select) {
          this.media.forEach(i => {
            if (i.media_type !== 'VIDEO') {
              this.importList.push(i)
            }
          })
        }
      }
    },
    categoriesOptions() {
      return this.categories ? this.categories.map(x => { return { label: x.name, value: x.id } }) : []
    },
    category: {
      get() {
        return this.categoriesOptions.find(x => x.value == this.info.category)
      },
      set(value) {
        this.info.category = value
      }
    },
    categories() {
      return this.getOptions('category')
    },
    options() {
      return this.$store.getters.options
    },
    optionsTags() {
      return this.$store.getters.options.filter(i => i.option_id !== 'category')
    }
  },
  methods: {
    validate(obj) {
      if (!obj.category) {
        this.errors.category = [
          this.$static('edit-item.category-require', 'Выберите категорию')
        ];

        this.$notify({
          title: this.$static('notify-сategory.title', 'Категорії'),
          type: 'error',
          text: this.errors.category.join('\n'),
          duration: 10000
        });
        return false
      }
      return true
    },
    selectOption(key, value) {
      try {
        if (this.info.advanced.options[key].indexOf(value) === -1) {
          this.info.advanced.options[key].push(value)
        }
      } catch (e) {
        this.info.advanced.options[key] = [value];
      }
    },
    selectedOption(key, value) {
      return this.info.advanced.options[key] ? this.info.advanced.options[key].indexOf(value) : -1
    },
    disconnect() {
      this.access_key = undefined;
      window.localStorage.removeItem('INSTA_ACCESS');
      this.connected = false;
    },
    loadJson(json) {
      this.fetching = false;
      if (json.data) {
        this.media.push(...json.data)
      }
      if (json.paging && json.paging.next) {
        this.nextPage = json.paging.next;
        // console.log(this.nextPage)
      } else {
        this.nextPage = undefined
      }
      if (json.error) {
        this.disconnect()
      }
    },
    fetchMedia() {
      if (this.fetching) {
        return
      }
      if (this.access_key) {
        this.connected = true;
        this.fetching = true;
        const params = new URLSearchParams(
          {
            access_token: this.access_key.access_token,
            fields: 'id,media_type,thumbnail_url,media_url,username,timestamp,caption'
          });
        fetch('https://graph.instagram.com/me/media?' + params.toString())
          .then(response => response.json())
          .then(json => {
            this.loadJson(json)
          })
          .catch((err) => {
            console.error(err);
            this.disconnect()
          })
      }
    },
    loadMore() {
      if (this.fetching || !this.nextPage) {
        return
      }
      this.fetching = true;
      fetch(this.nextPage)
        .then(response => response.json())
        .then(json => {
          this.loadJson(json)
        })
        .catch((err) => {
          console.error(err);
          this.disconnect()
        })
    },
    openFileManager() {
      // window.$('#file-manager').modal('show');
      //
      // this.$store.commit('onFileSelect', () => {
      //   let images           = this.$store.getters['fm/selectedItems'].map(i => '/storage/' + i.path);
      //   // console.log(images);
      //   this.settings.public = Object.assign(this.settings.public, {logo: images[0]})
      // })
    },

    getOptions(id) {
      let value = this.options.find(i => i.option_id === id);
      if (value) {
        return value.list.sort((a, b) => a.order - b.order)
      }
      return value
    },

    fetchSettings() {
      // api.get('/api/settings').then(response => response.data).then(data => {
      //   if (Array.isArray(data.env)){
      //     data.env = {}
      //   }
      //   this.settings = data;
      //   this.$store.commit('setSettings', data)
      // })
    },

    saveSettings() {
      if (!this.importList.length) {
        return
      }
      let obj = Object.assign({}, this.info, { list: this.importList, key: this.access_key });

      if (!this.validate(obj)) {
        return;
      }

      this.$notify({
        title: 'Instagram',
        type: 'info',
        text: this.$static('notify.simport', 'Починаю імпорт'),
        duration: 3000
      });
      api.post('/api/import/instagram', obj)
        .then(response => response.data)
        .then(data => {
          this.$notify(
            {
              title: 'Instagram',
              text: this.$static('notify.import', 'Успішно імпортовано'),
              duration: 3000
            });
          this.$router.push({ 'name': 'Catalog' })
        })
    }
  }
}
</script>

<style scoped></style>